import React from 'react';
import FamilyPlanningCatalogManager from '../familyPlanning/FamilyPlanningCatalogManager';

export default function HeadDoctorFamilyPlanningPage() {
  return <FamilyPlanningCatalogManager />;
}
